export default "__VITE_ASSET__BtsV8izI__"